import { ICONS_24PX_MAP } from './24px';
import { ICONS_56PX_MAP } from './56px';

export const ICONS_MAP = {
    '24px': ICONS_24PX_MAP,
    '56px': ICONS_56PX_MAP,
};
